/* eslint-disable @typescript-eslint/naming-convention */

const AUTH_ACTIONS = {
  /** Used to set auth state. Expects the complete state object in payload. */
  SET: 'AUTH_SET',
  /** Used to update auth state. Expects the partial state object in payload. */
  UPDATE: 'AUTH_UPDATE',
  LOGOUT: 'AUTH_LOGOUT',
  TOGGLE_REMEMBER_ME: 'AUTH_TOGGLE_REMEMBER_ME',
};

export default AUTH_ACTIONS;
